const STORAGE_KEY = "info_screen_device_token";

/** In-Memory-Fallback, wenn localStorage nicht verfügbar ist (Kiosk / privater Modus). */
let sessionToken: string | null = null;

export function getOrCreateInfoScreenDeviceToken(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing && existing.length >= 16) {
      sessionToken = existing;
      return existing;
    }
  } catch {
    // localStorage nicht verfügbar
  }

  if (sessionToken && sessionToken.length >= 16) {
    return sessionToken;
  }

  const token = `${crypto.randomUUID().replace(/-/g, "")}${crypto.randomUUID().replace(/-/g, "").slice(0, 8)}`;
  sessionToken = token;
  try {
    localStorage.setItem(STORAGE_KEY, token);
  } catch {
    // Token nur für diese Sitzung
  }
  return token;
}
